<div class="highlight" *ngIf="config">
  <giq-area-chart class="chart" [info]="info" [hideIndicators]="true"></giq-area-chart>
</div>